import { render, staticRenderFns } from "./ButtonStartVoice.vue?vue&type=template&id=caa68a76&scoped=true"
import script from "./ButtonStartVoice.vue?vue&type=script&lang=js"
export * from "./ButtonStartVoice.vue?vue&type=script&lang=js"
import style0 from "./ButtonStartVoice.vue?vue&type=style&index=0&id=caa68a76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa68a76",
  null
  
)

export default component.exports